// @flow
import React from "react";
import { NumberField } from "@quantum/ui";
import { Translate } from "@quantum/i18n";
import { connect } from "react-redux";
import {
  type ActionCreator,
  editarLambda,
  getLambdaSelecionado,
  getSeparadorDecimal,
} from "../../../../state";
import { VALOR_DEFAULT_LAMBDA } from "../../../../model";

type Prop = {
  lambda: number,
  separadorDecimal: string,
  editarLambda: ActionCreator,
};

function SelecaoLambda({ lambda, editarLambda, separadorDecimal }: Prop) {
  function handleLambdaEditado(lambda) {
    editarLambda(lambda);
  }

  function onBlur() {
    if (lambda !== 0 && !lambda) {
      editarLambda(VALOR_DEFAULT_LAMBDA);
    }
  }

  return (
    <div>
      <label className="ConfiguracaoMedida__label">
        <Translate>Comum.Lambda</Translate>
      </label>
      <NumberField
        className="ConfiguracaoMedida__input"
        allowNegative={false}
        decimalSeparator={separadorDecimal}
        thousandSeparator={""}
        max={1}
        min={0}
        onChangeValue={handleLambdaEditado}
        value={lambda}
        decimalScale={2}
        fixedDecimalScale={true}
        onBlur={onBlur}
      />
    </div>
  );
}

export default connect(
  state => ({
    lambda: getLambdaSelecionado(state),
    separadorDecimal: getSeparadorDecimal(state),
  }),
  { editarLambda }
)(SelecaoLambda);
